var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tw-text-left tw-text-light-grey tw-list-disc tw-text-xs"},[_c('li',[_vm._v("Must contain at least 8 characters")]),_c('li',[_vm._v("Must contain at least one Capital letter")]),_c('li',[_vm._v("A combination of numbers and letters")]),_c('li',[_vm._v("Use at least one special character (!$@%.)")])])
}]

export { render, staticRenderFns }